"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSectionWidget = void 0;
var react_1 = __importDefault(require("react"));
var QuoteSectionContext_1 = require("./QuoteSectionContext");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var getDiscountAmountOffText_1 = require("@CommonFrontend/Quote/getDiscountAmountOffText");
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var Expander_1 = require("../Expander");
var QuoteSectionSubtotal_1 = require("./QuoteSectionSubtotal");
var styles = __importStar(require("./QuoteSectionWidget.css"));
var QuoteSectionWidget = function (_a) {
    var attributes = _a.attributes, title = _a.title, body = _a.body;
    var _b = (0, QuoteSectionContext_1.useQuoteSectionContext)(), components = _b.components, price = _b.price, section = _b.section, _c = _b.actions, toggleSectionSelected = _c.toggleSectionSelected, toggleSectionCollapsed = _c.toggleSectionCollapsed, addSection = _c.addSection;
    var _d = section.display, collapsed = _d.collapsed, showSubtotal = _d.showSubtotal;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.wrapper) }),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.banner, direction: "horizontal", justify: "spaceBetween", align: "end", gap: "m" },
            react_1.default.createElement(DiscountPills, { price: price }),
            react_1.default.createElement("div", { className: styles.titleContainer }, title),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "m" },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: collapsed ? react_1.default.createElement(icons_1.ChevronRight, { key: "collapsed" }) : react_1.default.createElement(icons_1.ChevronDown, { key: "expanded" }), isRound: true, type: kaleidoscope_1.ButtonType.Secondary, onClick: toggleSectionCollapsed, tooltip: { content: collapsed ? "Expand section" : "Collapse section" } }),
                showSubtotal && react_1.default.createElement(QuoteSectionSubtotal_1.QuoteSectionSubtotal, { price: price }),
                section.selection.mode === "optional" && (react_1.default.createElement("div", { "data-interactive-zone": true },
                    react_1.default.createElement(kaleidoscope_1.Button, { isRound: true, onClick: toggleSectionSelected, "aria-pressed": section.selection.selected }, section.selection.selected ? "Selected" : "Select"))))),
        react_1.default.createElement(Expander_1.Expander, { open: !collapsed },
            react_1.default.createElement("div", { className: styles.body }, body)),
        react_1.default.createElement("div", { contentEditable: false }, components.OptionsMenu && (react_1.default.createElement("div", { "data-interactive-zone": true, className: styles.options },
            react_1.default.createElement(components.OptionsMenu, null)))),
        components.AddSectionButton && react_1.default.createElement(components.AddSectionButton, { onClick: addSection })));
};
exports.QuoteSectionWidget = QuoteSectionWidget;
var DiscountPills = function (_a) {
    var price = _a.price;
    var formatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    var firstPrice = Object.values(price)[0];
    if (!firstPrice) {
        return null;
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.discountPills, direction: "horizontal", gap: "xs" }, firstPrice.discounts.map(function (discount, index) {
        if (discount.target !== "self")
            return null;
        var amountOffText = (0, getDiscountAmountOffText_1.getDiscountAmountOffText)(discount.discount, formatter);
        return (react_1.default.createElement(kaleidoscope_1.Text, { key: index, className: styles.discountPill, strong: true }, discount.discount.type === "custom" ? amountOffText : "".concat(discount.discount.name, " ").concat(amountOffText)));
    })));
};
